import React from 'react';
import { Modal } from 'react-bootstrap';
import { downloadFromUrl } from '../../../../common/common';
import '../../../../components/centerModal/css/centerModal.scss';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { FiDownload } from '../../../../components/icons';
function ActivityModal(props) {
  return (
    <Modal
      className="centerModal"
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="fs-2 text-black fw-semibold">
          Activity Details (Ticket No - {props.data.master_referral_discussion_id})
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td className="fs-4 text-black fw-semibold">Case Topic</td>
              <td className="fs-4 text-black fw-normal">{props.data.referral_case_subject}</td>
            </tr>
            <tr>
              <td className="fs-4 text-black fw-semibold">Patient Details</td>
              <td>
                <h4 className="fs-4 text-black fw-normal">
                  {props.data.pat_first_name + ' ' + props.data.pat_last_name}{' '}
                  <span>
                    ({props.data.pat_gender} / {props.data.calc_pat_age})
                  </span>
                </h4>
                {props.data.operation_type == 2 && (
                  <h4 className="fs-4 text-black fw-normal">{props.data.pat_mobile}</h4>
                )}
              </td>
            </tr>
            <tr>
              <td className="fs-4 text-black fw-semibold">Case Condition</td>

              <td className="fs-4 text-black fw-normal">{props.data.case_condition_name}</td>
            </tr>
            <tr>
              <td colSpan="2">
                {/* {data.total_attachment} */}
                <div className="w-100">
                  {props.data.case_prescription?.length > 0 ? (
                    <h4 className="fs-4 text-black fw-semibold mb-2">Case Prescription</h4>
                  ) : null}

                  <div className="row cmnFileUploadShow mt-n3 ms-n3">
                    {props.data.case_prescription?.length > 0 ? (
                      <>
                        {typeof props.data.case_prescription == 'string'
                          ? JSON.parse(props.data.case_prescription)?.map((_r, ind) => (
                              <div
                                className="col-md-2 col-4 cmnFileUploadBox mt-3 ps-3"
                                key={ind + 1}
                              >
                                <div className="cmnFileUploadBoxIn rounded position-relative overflow-hidden">
                                  {!_r.fie_type.includes('image') ? (
                                    <LazyImage
                                      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                      className="mw-100 mh-100 w-auto h-auto"
                                    />
                                  ) : (
                                    <LazyImage
                                      src={_r.url}
                                      className="object-fit-cover w-100 h-100 float-start"
                                    />
                                  )}
                                  <a
                                    href={_r.url}
                                    target="_blank"
                                    download
                                    className="cmnFileUploadRemove rounded position-absolute d-flex justify-content-center align-items-center bg-white bg-opacity-75"
                                    onClick={() => {
                                      downloadFromUrl(_r.url);
                                    }}
                                  >
                                    <FiDownload customClass="fs-2 text-primary" />
                                  </a>
                                </div>
                              </div>
                            ))
                          : props.data.case_prescription?.map((_r, ind) => (
                              <div
                                className="col-md-2 col-4 cmnFileUploadBox mt-3 ps-3"
                                key={ind + 1}
                              >
                                <div className="cmnFileUploadBoxIn rounded position-relative overflow-hidden">
                                  {!_r.fie_type.includes('image') ? (
                                    <LazyImage
                                      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                      className=" mw-100 mh-100 w-auto h-auto"
                                    />
                                  ) : (
                                    <LazyImage
                                      src={_r.url}
                                      className="object-fit-cover w-100 h-100 float-start"
                                    />
                                  )}
                                  <a
                                    href={_r.url}
                                    target="_blank"
                                    download
                                    className="cmnFileUploadRemove rounded position-absolute d-flex justify-content-center align-items-center bg-white bg-opacity-75"
                                    onClick={() => {
                                      downloadFromUrl(_r.url);
                                    }}
                                  >
                                    <FiDownload customClass="fs-2 text-primary" />
                                  </a>
                                </div>
                              </div>
                            ))}
                      </>
                    ) : null}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td colSpan="2">
                {/* {data.total_attachment} */}
                <div className="w-100">
                  {props.data.case_reports?.length > 0 ? (
                    <h4 className="fs-4 text-black fw-semibold mb-2">Case Reports</h4>
                  ) : null}
                  <div className="row cmnFileUploadShow">
                    {props.data.case_reports?.length > 0 ? (
                      <>
                        {typeof props.data.case_reports == 'string'
                          ? JSON.parse(props.data.case_reports)?.map((_r, ind) => (
                              <div
                                className="col-md-2 col-4 cmnFileUploadBox mt-3 ps-3"
                                key={ind + 1}
                              >
                                <div className="cmnFileUploadBoxIn rounded position-relative overflow-hidden">
                                  {!_r.fie_type.includes('image') ? (
                                    <LazyImage
                                      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                      className=" mw-100 mh-100 w-auto h-auto"
                                    />
                                  ) : (
                                    <LazyImage
                                      src={_r.url}
                                      className="object-fit-cover w-100 h-100 float-start"
                                    />
                                  )}
                                  <a
                                    href={_r.url}
                                    target="_blank"
                                    download
                                    className="cmnFileUploadRemove rounded position-absolute d-flex justify-content-center align-items-center bg-white bg-opacity-75"
                                    onClick={() => {
                                      downloadFromUrl(_r.url);
                                    }}
                                  >
                                    <FiDownload customClass="fs-2 text-primary" />
                                  </a>
                                </div>
                              </div>
                            ))
                          : props.data.case_reports?.map((_r, ind) => (
                              <div
                                className="col-md-2 col-4 cmnFileUploadBox mt-3 ps-3"
                                key={ind + 1}
                              >
                                <div className="cmnFileUploadBoxIn rounded position-relative overflow-hidden">
                                  {!_r.fie_type.includes('image') ? (
                                    <LazyImage
                                      src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
                                      className=" mw-100 mh-100 w-auto h-auto"
                                    />
                                  ) : (
                                    <LazyImage
                                      src={_r.url}
                                      className="object-fit-cover w-100 h-100 float-start"
                                    />
                                  )}
                                  <a
                                    href={_r.url}
                                    target="_blank"
                                    download
                                    className="cmnFileUploadRemove rounded position-absolute d-flex justify-content-center align-items-center bg-white bg-opacity-75"
                                    onClick={() => {
                                      downloadFromUrl(_r.url);
                                    }}
                                  >
                                    <FiDownload customClass="fs-2 text-primary" />
                                  </a>
                                </div>
                              </div>
                            ))}
                      </>
                    ) : null}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </Modal.Body>
    </Modal>
  );
}
export default ActivityModal;
